import { atom } from '@reatom/framework'

type FeatureFlags = {
  platformsEnabled: boolean
}

const initialFeatureFlags: FeatureFlags = {
  platformsEnabled: false,
}

export const featureFlagsAtom = atom<FeatureFlags>(
  initialFeatureFlags,
  'featureFlagsAtom',
)
